import muster from '@dbk-legacy/muster';
import { variable } from '@dbk-legacy/muster/helpers';
import { getValues, ref } from '@dbk-legacy/muster/utils';
import calendar from './calendar-modal';
import startOfToday from 'date-fns/start_of_today';
import end_of_month from 'date-fns/end_of_month';
import end_of_year from 'date-fns/end_of_year';
import format from 'date-fns/format';
import { addDays, ymd } from '../utils/date';
import startOfYesterday from 'date-fns/start_of_yesterday';
import download from './utils/downloader';
// import PdfDownload from '../utils/attachment-download';

export default () => {
  const today = startOfToday();
  const yesterday = startOfYesterday();
  const past7Days = addDays(-6, yesterday);
  const past30Days = addDays(-30, yesterday);
  const past3Months = new Date(
    yesterday.getFullYear(),
    yesterday.getMonth() - 3,
    yesterday.getDate()
  );
  const startOfYTD = new Date(
    yesterday.getFullYear() - 1,
    yesterday.getMonth(),
    yesterday.getDate()
  );
  const startOfYear = new Date(new Date().getFullYear(), 0, 1);

  return muster()
    .path('report.busy', variable(false))
    .path('report.setBusy', {
      call: async ({ req }, { get, set }) => {
        await set('report.busy', true);
        await set('monthly.monthlyStatementsList', null);
        await set('daily.dailyStatementsList', null);
        await set('correspondence.correspondenceStatementsList', null);
        await set('advices.advicesItemLists', null);
        await set('advices.selectedAdviceLists', null);
        //advices.advicesItemLists
      },
    })

    .path('report.clearData', {
      call: async ({ req }, { get, set }) => {
        await set('monthly.monthlyStatementsList', '');
        await set('monthly.getMonthStatementList', '');
      },
    })

    .path('monthly.getMonthlyStatements', {
      call: async ({ req }, { get, set, call }) => {
        const { year, month, outputType } = req.args[0];

        var startDate = ymd(startOfYear);
        var endDate = ymd(yesterday);
        if (year == new Date().getFullYear() - 1) {
          startDate = ymd(new Date(new Date().getFullYear() - 1, 0, 1));
          endDate = ymd(end_of_year(startDate));
        }
        var [portfolioId] = await getValues(
          get('app.user.selectedPortfolioId')
        );
        const [oReturn] = await getValues(
          get(
            `roster.data.monthlyStatements.getData["${portfolioId}"]["${startDate}"]["${endDate}"]["${outputType}"]`
          )
        );
        await set([
          { path: 'report.busy', value: false },
          { path: 'monthly.startDate', value: startDate },
          { path: 'monthly.endDate', value: endDate },
          { path: 'monthly.monthlyStatementsList', value: JSON.parse(oReturn) },
        ]);
      },
    })

    .path('monthly.getMonthStatement', {
      call: async ({ req }, { get, set, call }) => {
        const {
          selectedYear,
          selectedMonth,
          outputType,
          selectedItems,
        } = req.args[0];
        var newDate = '1' + ' ' + selectedMonth + ' ' + selectedYear;
        var startDate = ymd(newDate);
        var endDate = ymd(end_of_month(newDate));
        var [portfolioId] = await getValues(
          get('app.user.selectedPortfolioId')
        );
        const [oReturn] = await getValues(
          get(
            `roster.data.monthly.getMonthStatement["${portfolioId}"]["${startDate}"]["${endDate}"]["${outputType}"]`
          )
        );
        await set([
          { path: 'report.busy', value: false },
          {
            path: 'monthly.startDate',
            value: format(new Date(startDate), 'DD MMM YYYY'),
          },
          {
            path: 'monthly.endDate',
            value: format(new Date(endDate), 'DD MMM YYYY'),
          },
          { path: 'monthly.portfolioId', value: portfolioId.replace('-', '.') },
          { path: 'ui.customtitle', value: selectedMonth + ' Month Statement' },
          { path: 'monthly.selectedMonth', value: selectedMonth },
          { path: 'monthly.selectedYear', value: selectedYear },
          { path: 'monthly.selectedItems', value: selectedItems },
          { path: 'monthly.getMonthStatementList', value: JSON.parse(oReturn) },
        ]);
        // if (outputType === 'current') {
        //   await call('ui.history.push', {
        //     pathname: '/reports/currentMonthStatement',
        //   });
        // } else {
        //   // await call('ui.history.push', { pathname: '/reports/monthStatement' });
        // }
      },
    })

    .path('monthly.getPdf', {
      call: async ({ req }, { get, set, call }) => {
        await set('dailyPdf.pdf', ' ');
        await set('monthly.pdf', ' ');
        let { docId } = req.args[0];
        let params = {
          docId: docId
        }
        await call('reports.getPdfBinary', params, req.args[1] );
        return;
      },
    })
    .path('reports.getPdfBinary', {
      call: async ({ req }, { get, set, call }) => {
        var [envitronmentUrl , apiversion] = await getValues(
          get([
            'settings.currentEnvironment.remoteUrl',
            'app.config.apiverion',
        ])
        );
        const [authHeader] = await getValues(get(['auth.authHeader']));
        const [userId] = await getValues(get(['auth.userId']));
        const [selectedPortfolio] = await getValues(
          get(['app.user.selectedPortfolioData'])
        );
        var x = new XMLHttpRequest();
        let params = req.args[0];
        params.acnum = userId;
        params.userId = userId;
        params.branchCode = selectedPortfolio.branchCode;
        let fileName = params.docId + '-' + Date.now() + '.pdf';
        x.open('POST', envitronmentUrl + '/reports/' + apiversion + '/download-pdf', true);
        //x.open("POST", "http://10.172.110.55:8080/TEST_DMS/download-pdf", true);
        x.setRequestHeader('Authorization-Token', authHeader);
        //x.setRequestHeader('Authorization', 'Bearer c09f9953461e86ea3aa82c2c632333ad');
        x.setRequestHeader('content-type', 'application/json');
        x.setRequestHeader('Accept', 'application/octet-stream');
        x.setRequestHeader(
          'Content-Disposition',
          'inline; filename=' + fileName
        );
        x.setRequestHeader(
          'Cache-Control',
          'no-cache, no-store, must-revalidate, post-check=0, pre-check=0'
        );
        x.setRequestHeader('Pragma', 'no-cache');
        //x.setRequestHeader('Expires', '0');
        x.setRequestHeader('expires', 'Tue, 01 Jan 1980 1:00:00 GMT');
        x.responseType = 'arraybuffer';
        const callbackfunction = req.args[1];
        x.onload = function (e) {
        callbackfunction();
        download(x.response, fileName, 'application/pdf');
        // PdfDownload(fileName, x.response, true);
        };
        x.send(JSON.stringify(params));
      },
    })

    .path('daily.onCalendarDone', {
      call: async ({ req }, { get, set, call }) => {
        var startDate = req.args[0];
        var endDate = req.args[1];
        if (startDate != undefined || endDate != undefined) {
          await set('daily.startDate', ymd(startDate));
          await set('daily.endDate', ymd(endDate));
          //await set('daily.isDateBarClickable', true);
          await call('daily.getDailyStatements', { outputType: 'daily' });
        }
      },
    })

    .import('daily.calendar', calendar(), {
      onDone: ref('daily.onCalendarDone'),
    })

    .path('correspondence.onCalendarDone', {
      call: async ({ req }, { get, set, call }) => {
        var startDate = req.args[0];
        var endDate = req.args[1];

        if (startDate != undefined || endDate != undefined) {
          await set('correspondence.startDate', ymd(startDate));
          await set('correspondence.endDate', ymd(endDate));
          //await set('correspondence.isDateBarClickable', true);
          await call('daily.getDailyStatements', {
            outputType: 'correspondence',
          });
        }
      },
    })

    .import('correspondence.calendar', calendar(), {
      onDone: ref('correspondence.onCalendarDone'),
    })

    .path('daily.getDailyStatements', {
      call: async ({ req }, { get, set, call }) => {
        let { outputType } = req.args[0];
        await call('report.setBusy');
        setTimeout(async () => {
          if (outputType === 'daily') {
            var [startDate] = await getValues(get('daily.startDate'));
            var [endDate] = await getValues(get('daily.endDate'));
          } else {
            var [startDate] = await getValues(get('correspondence.startDate'));
            var [endDate] = await getValues(get('correspondence.endDate'));
          }

          var [portfolioId] = await getValues(
            get('app.user.selectedPortfolioId')
          );
          var dateDisplay = '';

          if (startDate == endDate) {
            dateDisplay = 'Showing for ' + format(startDate, 'DD MMM YYYY');
          } else if (
            startDate != undefined &&
            startDate.length != 0 &&
            endDate != undefined &&
            endDate.length != 0
          ) {
            dateDisplay =
              'Showing: ' +
              format(startDate, 'DD MMM YYYY') +
              ' to ' +
              format(endDate, 'DD MMM YYYY');
          } else {
            dateDisplay = '';
          }

          const [oReturn] = await getValues(
            get(
              `roster.data.dailyStatements.getData["${portfolioId}"]["${startDate}"]["${endDate}"]["${outputType}"]`
            )
          );

          if (outputType === 'correspondence') {
            await set([
              { path: 'report.busy', value: false },
              { path: 'correspondence.startDate', value: startDate },
              { path: 'correspondence.endDate', value: endDate },
              { path: 'correspondence.dateDisplay', value: dateDisplay },
              {
                path: 'correspondence.correspondenceStatementsList',
                value: JSON.parse(oReturn),
              },
            ]);
          } else {
            await set([
              { path: 'report.busy', value: false },
              { path: 'daily.startDate', value: startDate },
              { path: 'daily.endDate', value: endDate },
              { path: 'daily.dateDisplay', value: dateDisplay },
              { path: 'daily.dailyStatementsList', value: JSON.parse(oReturn) },
            ]);
          }
        }, 100);
      },
    })

    .path('daily.getPdfLists', {
      call: async ({ req }, { get, set, call }) => {
        const { date, outputType, selectedItems } = req.args[0].selectedDate;
        var [portfolioId] = await getValues(
          get('app.user.selectedPortfolioId')
        );

        const [oReturn] = await getValues(
          get(
            `roster.data.daily.getPdfLists["${portfolioId}"]["${date}"]["${date}"]["${outputType}"]`
          )
        );

        await set([
          { path: 'report.busy', value: false },
          { path: 'dailyPdf.dateDisplay', value: date },
          { path: 'dailyPdf.selectedItems', value: selectedItems },
          {
            path: 'dailyPdf.portfolioId',
            value: portfolioId.replace('-', '.'),
          },
          { path: 'dailyPdf.dailyStatementsList', value: JSON.parse(oReturn) },
        ]);

        // if (outputType === 'correspondence') {
        //   await call('ui.history.push', {
        //     pathname: '/reports/CorrespondencePdfLists',
        //   });
        // } else {
        //   await call('ui.history.push', { pathname: '/reports/dailyPdfLists' });
        // }
      },
    })

    .path('trans.onCalendarDone', {
      call: async ({ req }, { get, set }) => {
        var startDate = req.args[0];
        var endDate = req.args[1];

        if (startDate !== undefined || endDate !== undefined) {
          await set('trans.startDate', ymd(startDate));
          await set('trans.endDate', ymd(endDate));
        } else {
          await set('trans.startDate', ymd(past7Days));
          await set('trans.endDate', ymd(yesterday));
        }
      },
    })

    .import('trans.calendar', calendar(), {
      onDone: ref('trans.onCalendarDone'),
    })

    .path('trans.getTransactionDetails', {
      call: async ({ req }, { get, set, call, watchValues }) => {
        var [startDate] = await getValues(get('trans.startDate'));
        var [endDate] = await getValues(get('trans.endDate'));

        var dateDisplay = '';

        if (startDate == endDate) {
          dateDisplay = 'Showing for ' + format(new Date(startDate), 'dd MMMM yyyy');
        } else if (
          startDate != undefined &&
          startDate.length != 0 &&
          endDate != undefined &&
          endDate.length != 0
        ) {
          dateDisplay =
            'Showing: ' +
            format(new Date(startDate), 'dd MMMM yyyy') +
            ' to ' +
            format(new Date(endDate), 'dd MMMM yyyy');
        } else {
          dateDisplay = '';
        }

        var [portfolioId] = await getValues(
          get('app.user.selectedPortfolioId')
        );
        const [oReturn] = await getValues(
          get(
            `roster.data.transactions.getData["${portfolioId}"]["${startDate}"]["${endDate}"]`
          )
        );

        await set([
          { path: 'report.busy', value: false },
          { path: 'trans.startDate', value: startDate },
          { path: 'trans.endDate', value: endDate },
          { path: 'trans.dateDisplay', value: dateDisplay },
          { path: 'trans.transactionHistoryList', value: JSON.parse(oReturn) },
          { path: 'trans.isLoading', value: false },
        ]);
      },
    })

    .path('trans.setRange7Days', {
      call: async ({ req }, { get, set, call }) => {
        await set('trans.isLoading', true);
        await set('trans.startDate', ymd(past7Days));
        await set('trans.endDate', ymd(yesterday));
      },
    })

    .path('trans.setRange30Days', {
      call: async ({ req }, { get, set, call }) => {
        await set('trans.isLoading', true);
        await set('trans.startDate', ymd(past30Days));
        await set('trans.endDate', ymd(yesterday));
      },
    })

    .path('trans.setRange3Months', {
      call: async ({ req }, { get, set, call }) => {
        await set('trans.isLoading', true);
        await set('trans.startDate', ymd(past3Months));
        await set('trans.endDate', ymd(yesterday));
      },
    })

    .path('trans.setRangeYTD', {
      call: async ({ req }, { get, set, call }) => {
        await set('trans.isLoading', true);
        await set('trans.startDate', ymd(past3Months));
        await set('trans.endDate', ymd(yesterday));
      },
    })

    .path('reports.getLastStatements', {
      call: async ({ req }, { get, set, call }) => {
        var [portfolioId] = await getValues(
          get('app.user.selectedPortfolioId')
        );
        await set('reports.lastMonthStatements', '');
        const [oReturn] = await getValues(
          get(`roster.data.reports.getLastStatements["${portfolioId}"]`)
        );
        await set('reports.lastMonthStatements', JSON.parse(oReturn));
      },
    })

    .path('reports.resetDates', {
      call: ({ req }, { set }) => {
        set('daily.startDate', ymd(past7Days));
        set('daily.endDate', ymd(yesterday));
        set('correspondence.startDate', ymd(past7Days));
        set('correspondence.endDate', ymd(yesterday));
        set('trans.startDate', ymd(past7Days));
        set('trans.endDate', ymd(yesterday));
      },
    })

    .path('reports.lastMonthStatements', variable(''))

    .path('trans.dateDisplay', variable(''))
    .path('trans.startDate', variable(ymd(past7Days)))
    .path('trans.endDate', variable(ymd(yesterday)))
    .path('trans.transactionHistoryList', variable())
    .path('trans.isLoading', variable(true))

    .path('daily.dateDisplay', variable(''))
    .path('daily.pdf', variable())
    .path('daily.startDate', variable(ymd(past7Days)))
    .path('daily.endDate', variable(ymd(yesterday)))
    .path('daily.isDateBarClickable', variable(false))
    .path('daily.dailyStatementsList', variable())
    .path('monthly.getMonthStatementList', variable(''))
    .path('monthly.pdf', variable())
    .path('monthly.monthlyStatementsList', variable())
    .path('monthly.startDate', variable())
    .path('monthly.portfolioId', variable())
    .path('monthly.endDate', variable())
    .path('monthly.selectedMonth', variable())
    .path('monthly.selectedYear', variable())
    .path('monthly.selectedItems', variable())

    .path('dailyPdf.dateDisplay', variable(''))
    .path('dailyPdf.portfolioId', variable(''))
    .path('dailyPdf.pdf', variable())
    .path('dailyPdf.selectedItems', variable())
    .path('dailyPdf.dailyStatementsList', variable())

    .path('correspondence.dateDisplay', variable(''))
    .path('correspondence.startDate', variable(ymd(past7Days)))
    .path('correspondence.endDate', variable(ymd(yesterday)))
    .path('correspondence.isDateBarClickable', variable(false))
    .path('correspondence.correspondenceStatementsList', variable());
};

